import { generate } from '@/utils/request';
import { VUE_APP_WAVE_API } from '@/utils/index';
const env = VUE_APP_WAVE_API();
const config = {
  prefix: '',
  items: [
    // 马光浩 http://192.168.0.39:8090
    // 何雪松 http://192.168.0.104:8090
    // 根据货架号获取大屏数据：货架号、波次号、商品列表 ==》 马光浩
    { key: 'getWavePageFirst', url: env + '/pick-order/sorting/{sortingStation}', method: 'get' },
    // 波次号列表 ==》 何雪松
    { key: 'getWaveList', url: env + '/v1/waveList/page', method: 'post' },
    // 波次号列表 ==》 rex
    { key: 'delWaveList', url: env + '/v1/waveList/deleteById?id={id}', method: 'delete' },
    // 波次详情(旧) ==》 何雪松
    { key: 'getWaveDetail', url: env + '/v1/waveOrder/page', method: 'post' },
    // 波次详情(新) ==》 马光浩
    { key: 'getWaveDetailNew', url: env + '/v1/waveOrder/list', method: 'post' },
    // 波次详情：历史弹窗 ==》 何雪松
    { key: 'getWaveHistory', url: env + '/pick-order/getOrderPickHistory', method: 'post' },
    // 波次详情：view二合一弹窗(上) ==》 马光浩
    { key: 'getWaveViewTop', url: env + '/pick-order/getOrderPickInfo', method: 'post' },
    // 波次详情：更改状态：==> pick：拣货, sort：分拣 ,pack：打包 ,completed：完成 ,skip：跳过 ==》 何雪松
    { key: 'putWaveDetailSkip', url: env + '/v1/waveOrder/updateWave', method: 'put' },
    // 波次详情：关单 ==》 rex  /v1/waveOrder/hjCloseOrder
    { key: 'hjCloseOrder', url: env + '/v1/waveOrder/hjCloseOrder?wmsId={wmsId}', method: 'put' },
    // 波次详情：打印全部 ==》 马光浩
    { key: 'printAllWaveDetail', url: env + '/pick-order/batch/print/wave', method: 'post' },
    // 波次详情：打印 ==》 何雪松
    { key: 'printWaveDetail', url: env + '/v1/waveOrder/wavePrint', method: 'post' },
    // 分拣台列表 ==》 何雪松
    { key: 'getSortingStationList', url: env + '/v1/sortingStation/page', method: 'post' },
    // 分拣台列表 新增 ==》 何雪松
    { key: 'addSortingStation', url: env + '/v1/sortingStation/creatSortingStation', method: 'post' },
    // 分拣台列表 编辑 ==》 何雪松
    { key: 'editSortingStation', url: env + '/v1/sortingStation/updateSortingStation', method: 'post' },
    // 分拣台列表 删除 ==》 何雪松
    { key: 'delSortingStation', url: env + '/v1/sortingStation/deleteSortingStation?id={id}', method: 'delete' },
    // 灯架配置 列表 ==》 马光浩
    { key: 'getLampPageList', url: env + '/lampHolder/pageList', method: 'post' },
    // 灯架配置 新增 ==》 马光浩
    { key: 'addLampPageList', url: env + '/lampHolder/save', method: 'post' },
    // 灯架配置 编辑 ==》 马光浩
    { key: 'editLampPageList', url: env + '/lampHolder/update', method: 'post' },
    // 灯架配置 删除 ==》 马光浩
    { key: 'delLampPageList', url: env + '/lampHolder/delete', method: 'post' },

    // NSTD 列表 ==》 马光浩        post   /orderTagRule/list
    { key: 'getNSTDList', url: env + '/orderTagRule/list', method: 'post' },
    // NSTD 列表 ==》 马光浩        post   /orderTagRule/page
    { key: 'getNSTDPage', url: env + '/orderTagRule/page', method: 'post' },
    // NSTD 列表新增 ==》 马光浩        post   /orderTagRule/create
    { key: 'addNSTDList', url: env + '/orderTagRule/create', method: 'post' },
    // NSTD 列表删除 ==》 马光浩        delete   /orderTagRule/delete
    { key: 'delNSTDList', url: env + '/orderTagRule/delete', method: 'delete' },
    // NSTD 列表修改 ==》 马光浩        put   /orderTagRule/update
    { key: 'editNSTDList', url: env + '/orderTagRule/update', method: 'put' },

    // 外部平台顶部展示 ==》 马光浩        post   /platform-order/order-count
    { key: 'getOrdersNum', url: env + '/platform-order/order-count', method: 'post', loadingHide: true, },
    // 外部平台订单列表 ==》 马光浩        post   /platform-order/pageList
    { key: 'getOrdersList', url: env + '/platform-order/pageList', method: 'post' },
    // 外部平台订单状态 ==》 马光浩        post   /platform-order/order-status
    { key: 'getOrdersStatus', url: env + '/platform-order/order-status', method: 'post', loadingHide: true, },
    // 外部平台 订单抓取 ==》 马光浩        post   /platform-order/order-pull
    { key: 'pullOrders', url: env + '/platform-order/order-pull', method: 'post', },
    // 外部平台 订单重试 ==》 马光浩        post   /platform-order/order-retry
    { key: 'retryOrders', url: env + '/platform-order/order-retry', method: 'post', },

    // EDI 列表 ==》 朱总       get  /edi/v1/{code}/po
    { key: 'getEDIPageList', url: env + '/edi/v1/{code}/po', method: 'get', },
    // EDI 列表顶部四卡片 ==》 朱总   /edi/v1/{code}/po/stats
    { key: 'getEDIPageCard', url: env + '/edi/v1/{code}/po/stats', method: 'get',loadingHide: true, },
    // EDI 列表retailers下拉框 ==》 朱总   /edi/v1/{code}/sys/retailers
    { key: 'getEDIPageRetailers', url: env + '/edi/v1/{code}/sys/retailers', method: 'get',loadingHide: true, },
    // EDI 列表 操作栏 重试 ==》 朱总   /edi/v1/{code}/po/{id}/status
    { key: 'retryEDIPageData', url: env + '/edi/v1/{code}/po/{id}/status?status={status}', method: 'post', },
    // EDI 详情 ==》 朱总       get  /edi/v1/{code}/po/{id}
    { key: 'getEDIPageDetail', url: env + '/edi/v1/{code}/po/{id}', method: 'get', },
    // EDI 详情底部Tab页： EDI payload  ==》 朱总       get  /edi/v1/{code}/po/{id}/file
    { key: 'getEDIPageDetailPayload', url: env + '/edi/v1/{code}/po/{id}/file', method: 'get', },
    // EDI 审核按钮： EDI payload  ==》 朱总       POST /edi/v1/{code}/po/{id}/csg-approved
    { key: 'EDIPageApprove', url: env + '/edi/v1/{code}/po/{id}/csg-approved', method: 'post', },
  ],
};

export default {
  ...generate(config),
};
